var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.133 19.7652V35H0V22.9632C0 16.4488 0.772781 11.7407 2.34806 8.88325C4.46622 4.89155 7.90546 1.75292 12.0821 0L15.307 5.10787C12.8161 6.0534 10.7206 7.81226 9.36253 10.0973C7.90643 13.1105 7.17863 16.4215 7.23739 19.7652H14.133ZM36.826 19.7652V35H22.693V22.9632C22.693 16.4488 23.4658 11.7407 25.0411 8.82403C27.1739 4.85753 30.6106 1.74208 34.7751 0L38 5.10787C35.5091 6.0534 33.4136 7.81226 32.0555 10.0973C30.5994 13.1105 29.8716 16.4215 29.9304 19.7652H36.826Z",
    fill: "#45446B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.226d4937d894c99fd799d9f565d5dce5.svg";
export { ForwardRef as ReactComponent };